import React from 'react'
import { ContentBlockFragment } from '@contentsite/src/graphql/generated/graphql-types'
import {
  CardHorizontal,
  CardHorizontalProps,
} from '@dustin-web/content-components/src/cards/card-horizontal/card-horizontal'
import { BlockList } from '..'
import { Image } from '../../../graphql/generated/graphql-types'
import { cloudflareImageLoader } from '@dustin-web/microsite-components/src/image/cloudflare-loader'

export type CardCTAHorizontalBlockProps = CardHorizontalProps & {
  footer?: ContentBlockFragment[]
  mainImageUrl?: string
}
export const CardCTAHorizontalBlock = (props: CardCTAHorizontalBlockProps) => {
  const mainImage = props.mainImageUrl
    ? { url: props.mainImageUrl }
    : props.mainImage
      ? {
          ...props.mainImage,
          url: cloudflareImageLoader({
            src: props.mainImage?.url || '',
            width: props.stretchImage ? 600 : undefined,
          }),
        }
      : null
  return (
    <div className="u-mb-16">
      <CardHorizontal
        {...props}
        customContent={props.footer && <BlockList blocks={props.footer} />}
        mainImage={mainImage as Image}
      />
    </div>
  )
}
